module.exports = __webpack_public_path__ + "img/jewelry.7b34a451.webp";